import { useEffect, useRef } from 'react';
import EditComponent from './MembershipPointsPlansEdit';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx'
import { columnsheadId } from '../../universal/columnshead';
import dayjs from 'dayjs';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    useEffect(() => {
    }, []);

    //表头
    const columnsHead = [
        {
            title: '方案',
            dataIndex: 'planName',
        },
        {
            title: '获取',
            dataIndex: 'isEarn',
            render: (val: boolean) => val === true ? '是' : '否'
        },
        {
            title: '方法',
            dataIndex: 'earnPointsMethod',
            render: (val: any) => val?.name
        },
        {
            title: '兑换',
            dataIndex: 'isRedeem',
            render: (val: boolean) => val === true ? '是' : '否'
        },
        {
            title: '最低/上限',
            dataIndex: 'id',
            render: (val: string, record: any) => `${record?.minimumPointsRedemptionThreshold}/${record?.maximumPointsRedemptionLimit}`
        },
        {
            title: '使用规则',
            dataIndex: 'isPermanentUse',
            render: (val: boolean, record: any) => {
                return (
                    val === true ?
                        '永久使用' :
                        `${dayjs(record?.startDate).format('YYYY-MM-DD')} 至 ` +
                        `${dayjs(record?.endDate).format('YYYY-MM-DD')}；` +
                        `${record?.totalCopies - record?.usedCopies}/${record?.totalCopies}`
                )
            }
        },
        {
            title: '排序',
            dataIndex: 'sorting',
            sorter: true
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '会员积分方案',
        apiId: 'membershipPointsPlans',
        columns,
        showStates: true,
        EditComponent,
        serviceId: 'business'
    };

    return (
        <>
            <WebUniversal props={extendProps} ref={ref} />
        </>
    )
}

export default WebComponent;
